



































































import { WithErrorModal } from '@/components/organisms/dialog/error-dialog/with-error-modal'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { log } from '@/log'
import { ApiCreditcard } from '@/models/api/creditcard'
import { WithCreditcardForSubscriptionRepository } from '@/models/payment/creditcard/context/for-subscription/mixin'
// import ActionToPlan from '@spa/components/pages/mypage/paid-membership/plans/ActionToPlan.vue'
import ActionToPlan from '@spa/components/pages/mypage/paid-membership/plans/ActionToPlanTemporally.vue'
import PlanGroupHeader from '@spa/components/pages/mypage/paid-membership/plans/components/PlanGroupHeader.vue'
import { PlanGroupViewModel } from '@spa/components/pages/mypage/paid-membership/plans/models/plan-group'
import {
  DefaultPlanGroupViewModelRepository,
  PlanGroupViewModelRepository,
} from '@spa/components/pages/mypage/paid-membership/plans/models/repository/plan-group-repository'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { none, Option } from 'fp-ts/lib/Option'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

type MixedIn = LoadingMixin
  & WithCreditcardForSubscriptionRepository
  & WithErrorModal

@Component({
  components: {
    ActionToPlan,
    PlanGroupHeader,
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
    WithCreditcardForSubscriptionRepository,
  ],
})
export default class PaidMembershipPlansPage extends Mixins<MixedIn>(
  LoadingMixin,
  WithCreditcardForSubscriptionRepository,
  WithErrorModal
) {
  @Prop({
    default: () => DefaultPlanGroupViewModelRepository.forHost,
  })
  readonly planGroupRepository: PlanGroupViewModelRepository

  status: Status = Status.Pending

  planGroups: PlanGroupViewModel[] = []

  creditcard: Option<ApiCreditcard> = none

  async created() {
    try {
      this.status = Status.Loading

      await Promise.all([
        this.$store.dispatch('user/get'),
        this.planGroupRepository.list().then(
          maybeGroups => maybeGroups.fold(
            errors => log.error({ errors }),
            groups => this.planGroups = groups
          )
        ),
        this.creditCardForSubscriptionRepository.findRegistered().then((card) => {
          this.creditcard = card
        }),
      ])
    } catch (error) {
      log.error(error)
    } finally {
      this.status = Status.Completed
    }
  }

  get isLoading(): boolean {
    return this.status === Status.Pending
  }

  get isPaidMember(): boolean {
    return this.$store.getters['user/isPaidMember']
  }

  get remainingPurchaseCount(): number|null {
    const remainingCount = this.$store.getters['user/remainingCountForPaidMembershipPrice']
    if (!remainingCount) {
      return null
    }

    // 何らかの問題が発生して負数がサーバーから返却されることがある
    // それ自体はエラーだがユーザーに負数を見せるのを避けるため、0に丸める
    return Math.max(0, remainingCount.purchase_not_considering_current_cart)
  }
}
